import { combineReducers } from '@reduxjs/toolkit';

import formReducer from './form/slice/formSlice';
import gridReducer from './grid/slice/gridSlice';

const clienteReducer = combineReducers({
  form: formReducer,
  grid: gridReducer,
});

export default clienteReducer;
